export * from './CertificateTemplate';
